// components/SolutionsPageSection.jsx
import { useState } from 'react';
import SectionReveal from './SectionReveal';
import WaterClean from './Watherclean';
const defaultTabs = [
    {
        id: 'municipal',
        title: 'Համայնքային կեղտաջրերի մաքրում',
        desc: 'Ժամանակակից մաքրման կայաններ քաղաքների, համայնքների և բնակավայրերի համար։',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRET8qJe1Wz3GBuQguMxIOWGkCVFchbSEXgD1m5Y7s4cTqaPDHcsSr_UWMT&s=10',
        items: ['Կենսաբանական մաքրում', 'Մեխանիկական մաքրում', 'Տիղմի մշակում', 'Հոտերի վերահսկում', 'Ավտոմատ կառավարման համակարգեր']
    },
    {
        id: 'industrial',
        title: 'Արդյունաբերական կեղտաջրերի մաքրում',
        desc: 'Լուծումներ տարբեր արտադրական ճյուղերի համար։',
        image: 'https://www.tcc-ofc.com/icms/upload/8c1596b0d70811efb0b53f05ea08c0ff/ckftpdata/images/2025317/1742209536959/upload_30dd01c186cdf380344cfe62c04e4954.webp',
        items: ['Սննդի արդյունաբերություն', 'Գինեգործություն', 'Կաթնամթերքի արտադրություն', 'Մետաղամշակում', 'Ավտոլվացման կետեր', 'Հանքարդյունաբերություն', 'Քիմիական արտադրություն']
    },
    {
        id: 'drinking',
        title: 'Խմելու ջրի մաքրում',
        desc: 'Մենք առաջարկում ենք ժամանակակից տեխնոլոգիաներ։',
        image: 'https://rare-water.com/cdn/shop/articles/AdobeStock_857748338.jpg?v=1738116033',
        items: ['Ֆիլտրացիա', 'Ուլտրամանուշակագույն ախտահանում (UV)', 'Մեմբրանային համակարգեր', 'Ածխային ֆիլտրեր', 'Ջրի որակի մշտադիտարկում']
    },
    {
        id: 'local',
        title: 'Տեղային մաքրման կայաններ',
        desc: 'Լուծումներ տարբեր օբյեկտների համար։',
        image: 'https://static.tildacdn.one/tild6635-6162-4265-b138-306139373032/bg.jpeg',
        items: ['Առանձնատներ', 'Բնակելի համալիրներ', 'Հյուրանոցներ', 'Դպրոցներ', 'Մանկապարտեզներ', 'Առողջարաններ', 'Հանգստյան գոտիներ']
    },
    {
        id: 'sanitary',
        title: 'Ժամանակակից հանրային սանիտարական համակարգեր',
        desc: 'Ինքնամաքրվող հանրային զուգարաններ և խելացի համակարգեր։',
        image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=800&q=80',
        items: ['Մոդուլային լուծումներ', 'Խելացի կառավարման համակարգեր', 'Հասանելիություն սահմանափակ շարժունակություն ունեցող անձանց համար', 'Էներգաարդյունավետ շահագործում']
    },
    {
        id: 'reuse',
        title: 'Ջրի վերաօգտագործում',
        desc: 'Մաքրված ջրի օգտագործում տարբեր նպատակներով։',
        image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80',
        items: ['Ոռոգման համար', 'Կանաչ տարածքների սպասարկում', 'Տեխնիկական գործընթացներ', 'Արդյունաբերական նպատակներ']
    }
];

export default function SolutionsPageSection({ t }) {
    const tabs = t?.solutionsTabs || defaultTabs;
    const [activeTab, setActiveTab] = useState(0);
    const [animKey, setAnimKey] = useState(0);

    const activeTabIndex = tabs.length ? Math.min(activeTab, tabs.length - 1) : 0;
    const activeTabItem = tabs[activeTabIndex] || defaultTabs[0];

    const prevTab = () => {
        if (!tabs.length) return;
        setAnimKey(prev => prev + 1);
        setActiveTab((prev) => (prev === 0 ? tabs.length - 1 : prev - 1));
    };

    const nextTab = () => {
        if (!tabs.length) return;
        setAnimKey(prev => prev + 1);
        setActiveTab((prev) => (prev === tabs.length - 1 ? 0 : prev + 1));
    };

    const selectTab = (idx) => {
        if (!tabs.length) return;
        setAnimKey(prev => prev + 1);
        setActiveTab(idx);
    };

    return (
        <section id="solutions-page" className="relative bg-white px-3 py-16 md:px-10">

            <div className="mx-auto max-w-7xl space-y-10">

                {/* Заголовок */}
                <SectionReveal>
                    <div className="border-l-4 border-[#0FA4E8] bg-gray-50 p-6 md:p-10">
                        <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-4">
                            {t?.solutionsTitle || 'Լուծումներ'}
                        </h2>
                        <p className="text-lg font-bold text-[#0B3B6F] mb-3">
                            {t?.solutionsSubtitle || 'Ժամանակակից ջրային լուծումներ Հայաստանի համար'}
                        </p>
                        <p className="text-sm md:text-base text-slate-600 leading-relaxed max-w-3xl">
                            {t?.solutionsDesc || 'NWTA-ն առաջարկում է ամբողջական ինժեներական լուծումներ ջրամատակարարման, կեղտաջրերի մաքրման և ջրային ենթակառուցվածքների զարգացման ոլորտում։'}
                        </p>
                    </div>
                </SectionReveal>

                <WaterClean t={t} />
                {/* Слайдер */}
                <SectionReveal delay={150}>
                    <div className="border-l-4 border-[#0B3B6F] p-3 overflow-hidden">

                        {/* Верхняя панель */}
                        <div className="flex items-center justify-between bg-gray-50 p-3 md:p-4">

                            <button
                                onClick={prevTab}
                                className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white border border-gray-400 hover:border-[#0FA4E8] hover:text-[#0FA4E8] transition-all text-[#0B3B6F]"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <path d="M15 18l-6-6 6-6" />
                                </svg>
                            </button>

                            <div className="flex-1 flex items-center justify-center gap-2 px-4">
                                <span className="text-sm md:text-base font-bold text-[#0B3B6F]">
                                    {activeTabItem.title}
                                </span>
                            </div>

                            <button
                                onClick={nextTab}
                                className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white border border-gray-400 hover:border-[#0FA4E8] hover:text-[#0FA4E8] transition-all text-[#0B3B6F]"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <path d="M9 18l6-6-6-6" />
                                </svg>
                            </button>
                        </div>

                        {/* Контент с анимацией */}
                        <div key={animKey} className="md:grid md:grid-cols-5">

                            {/* Фото - видно на мобильных */}
                            <div className="md:col-span-2 relative h-48 md:h-[400px] overflow-hidden">
                                <div
                                    className="absolute inset-0 bg-cover bg-center animate-zoomIn"
                                    style={{ backgroundImage: `url('${activeTabItem.image}')` }}
                                />
                                <div className="absolute inset-0 bg-[#0B3B6F]/10" />
                            </div>

                            {/* Список */}
                            <div className="md:col-span-3 bg-gray-50 p-5 md:p-10">
                                <p className="text-sm text-slate-500 mb-4 md:mb-6 animate-slideUp">
                                    {activeTabItem.desc}
                                </p>
                                <div className="grid gap-2 sm:grid-cols-2">
                                    {(activeTabItem.items || []).map((item, idx) => (
                                        <div
                                            key={idx}
                                            className="flex items-center gap-3 p-3 bg-white border border-gray-100 hover:border-[#0FA4E8]/30 transition-all group animate-slideUp"
                                            style={{ animationDelay: `${150 + idx * 50}ms` }}
                                        >
                                            <span className="flex-shrink-0 text-[#0FA4E8]">
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <polyline points="20 6 9 17 4 12" />
                                                </svg>
                                            </span>
                                            <span className="text-sm font-medium text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors">
                                                {item}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>

                        {/* Точки + счётчик */}
                        <div className="flex items-center justify-between p-3 bg-gray-50">
                            <span className="text-xs text-slate-400 font-medium">
                                {String(activeTab + 1).padStart(2, '0')} / {String(tabs.length).padStart(2, '0')}
                            </span>
                            <div className="flex gap-2">
                                {tabs.map((_, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => selectTab(idx)}
                                        className={`w-2 h-2 rounded-full transition-all ${idx === activeTab ? 'bg-[#0FA4E8] w-6' : 'bg-gray-300 hover:bg-gray-400'
                                            }`}
                                    />
                                ))}
                            </div>
                        </div>

                    </div>
                </SectionReveal>

            </div>
        </section>
    );
}